import React from 'react';
import { ScrollLink } from "react-scroll";
import {Link} from "react-router-dom";
import '../../../styles/tutorial archive/Themes.css';

// Images
const Images = {
    cursor: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Cursor.png"),
    mainelements: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/MainElements.png"),
    cursorexample: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/CursorExample.png"),
    button: require("../../../Assets/Site Assets/ui-button.png"),

    eula_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/H&S/EULA_Breakdown.png"),
    nlc_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/H&S/NLC_Breakdown.png"),
    hs_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/H&S/HS_Breakdown.png"),

    normal_prompt_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/PromptObject/PromptExample.png"),
    input_prompt_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/PromptObject/InputPromptExample.png"),
    transition_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/TransitionMenu.png"),

    mainmenu_layer1: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Main Menu/Menu_Layer 1.png"),
    mainmenu_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Main Menu/Menu_Layer 2.png"),

    songselect_layer1: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/SongSelection/SongSelection_Layer1.png"),
    songselect_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/SongSelection/SongSelection_Layer2.png"),
    songselect_layer3: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/SongSelection/SongSelection_Layer3.png"),

    leaderboards: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/LeaderboardsMenu.png"),

    modifiersmenu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ModifiersMenu.png"),

    settingsmenu_layer1: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/SettingsMenu/SettingsMenu_Layer1.png"),
    settingsmenu_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/SettingsMenu/SettingsMenu_Layer2.png"),

    report_reason: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ReportMenu/Report_ReasonScreen.png"),
    report_sending: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ReportMenu/Report_SendingScreen.png"),
    report_sent: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ReportMenu/Report_SentScreen.png"),
    report_error: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ReportMenu/Report_ErrorScreen.png"),

    environment_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/EnvironmentMenu.png"),

    pah_layer1: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/PlayerAccountHub/PAH_Layer 1.png"),
    pah_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/PlayerAccountHub/PAH_Layer 2.png"),

    customs_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/CustomSongsMenu.png"),

    marketplace_layer1a: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Marketplace/marketplace_layer1_a.png"),
    marketplace_layer1b: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Marketplace/marketplace_layer1_b.png"),
    marketplace_layer1c: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Marketplace/marketplace_layer1_c.png"),
    marketplace_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Marketplace/marketplace_layer2.png"),
    marketplace_layer3: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Marketplace/marketplace_layer3.png"),
    marketplace_layer4: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Marketplace/marketplace_layer4.png"),


    practice_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/PracticeMenu.png"),

    coming_screen: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ComingSoonMenu.png"),

    themes_layer1: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ThemeMenu/ThemeMenu_Layer1.png"),
    themes_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/ThemeMenu/ThemeMenu_Layer2.png"),

    theme_devenv: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/DeveloperThemeDashboardMenu.png"),

    nb_layer1: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Noticeboard/NB_Layer1.png"),
    nb_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Noticeboard/NB_Layer2.png"),

    multiplayer_loading: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/LoadingMultiplayerScreen.png"),
    multiplayer_error: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/MultiplayerErrorScreen.png"),

};

//Animations
const Animations = {
    CreateFile: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Directions/Create File.gif"),
    OpenFile: require("../../../Assets/Tutorials/Themes Tutorial/Page 2 - Menu.polybeatsconfig/Directions/Open File.gif"),
};

const otherAssets = {
    square: require("../../../Assets/Website Pack/Square.png"),
}

export default function themeTutorial() {
    return (
        <div className="about-frame">

                <div id="about">
                    <p>Menu.polybeatsconfig (file)</p>
                </div>
                <span className="normal-text">
                    This is where all the UI of Poly Beats can be configured. Colors, and also settings to trigger certain actions.
                <br></br>
                <br></br>
                This file is really huge, so it may take a bit of time to get everything exactly the way you want. Don't be discouraged! Greatness takes time.</span>
                <div className="about-leftalign">
                    <br></br>
                    <br></br>
                    <div className="about-leftalign">
                        <p><br/><br/>TABLE OF CONTENTS</p>

                        {/* Table of Contents */}


                        <ul className="toc">
                            <li><a href="#main-elements">Main Elements</a></li>
                            <li><a href="#health-and-safety-menu">Health and Safety Menu</a></li>
                            <li><a href="#prompt-object-menu">Prompt Object Menu</a></li>
                            <li><a href="#transition-manager-menu">Transition Manager Menu</a></li>
                            <li><a href="#main-menu">Main Menu</a></li>
                            <li><a href="#song-selection">Song Selection</a></li>
                            <li><a href="#leaderboards">Leaderboards</a></li>
                            <li><a href="#modifiers-menu">Modifiers Menu</a></li>
                            <li><a href="#settings-menu">Settings Menu</a></li>
                            <li><a href="#report-menu">Report Menu</a></li>
                            <li><a href="#environment-menu">Environment Menu</a></li>
                            <li><a href="#custom-songs-menu">Custom Songs Menu</a></li>
                            <li><a href="#marketplace-menu">Marketplace Menu</a></li>
                            <li><a href="#practice-mode-menu">Practice Mode Menu</a></li>
                            <li><a href="#player-account-hub">Player Account Hub</a></li>
                            <li><a href="#coming-soon-screen">Coming Soon Screen</a></li>
                            <li><a href="#theme-menu">Theme Menu</a></li>
                            <li><a href="#developer-theme-dashboard-menu">Developer Theme Dashboard Menu</a></li>
                            <li><a href="#noticeboard-menu">Noticeboard Menu</a></li>
                            <li><a href="#multiplayer-connecting-menu">Multiplayer Connecting Menu</a></li>
                            <li><a href="#multiplayer-connect-error-screen">Multiplayer Connect Error Screen</a></li>
                        </ul>

                    </div>


                    {/* Sections to jump to */}
                    <div id="menu.polybeatsconfig" className="sectionFormatting">
                        <br></br>
                        <div id="main-elements" className="sectionFormatting">
                            <p>If you didn't download the template, create the file like this:
                                <br></br>
                                <br></br>
                                <img
                                    src={Animations.CreateFile}
                                    style={{height: "259px", width: "460px"}}
                                    alt="Create File"
                                /></p>
                            <p>Then, (you too, Template users) open the file, like this:
                                <br></br>
                                <br></br>
                                <img
                                    src={Animations.OpenFile}
                                    style={{height: "259px", width: "460px"}}
                                    alt="Open File"
                                /></p>

                            <h2>"MainElements"</h2>
                            <p>There are a lot of reused things in Poly Beats we would rather you only keep consistent.
                                It'll make for a better player experience so we force the fact that the following few
                                things
                                have to have consistent colors...</p>
                            <p>To start making color differences to this stuff, first off, add a JSON Array to your
                                Menu.polybeatsconfig file, which copies the big rose-red title text just above me, in
                                quotation marks.
                                <br></br>
                                You are going to do this for every piece of big rose-red text you see in this guide.</p>

                            <img
                                src={Images.mainelements}
                                style={{height: "137px", width: "604.6px"}}
                                alt="You may not have the syntax highlighting (colors around the letters and symbols)."
                            />
                            <p>Now, inside the curly braces -> &#123; and &#125;, we can add colors in this format: </p>
                            <code>"property name": "#color hex value"</code>
                            <p>(and yes, you do need the quote marks.)
                                <br></br>To demonstrate this, lemme show you the first property.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.cursor}
                                    style={{height: "120px", width: "120px"}}
                                    alt="Cursor.png!"
                                />
                                <div>
                                    <h3>Cursor_Color</h3>
                                    <p> This is the color used for the cursor, which the player sees for the entire
                                        game.
                                        The outline color doesn't change, to keep visibility, so you can only change the
                                        inner color.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <p>Cursor_Color is the property name, and we're told it's a color property, so in our JSON
                                we
                                will do this...</p>
                            <img
                                src={Images.cursorexample}
                                style={{height: "135px", width: "596px"}}
                                alt="You may not have the syntax highlighting (colors around the letters and symbols)."
                            />
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.button}
                                    style={{height: "53.1px", width: "210px"}}
                                    alt="Cursor.png!"
                                />
                                <div>
                                    <h3>MainButton_Color</h3>
                                    <p> This is the color used for every single button you see in Poly Beats. EVERY
                                        SINGLE
                                        ONE. So it's important to not mess this one up.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h3>MainButton_TextColor</h3>
                                    <p> For the text inside the Main Button. It could be anything. You'll probably want
                                        this
                                        to be the same color as your button.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="health-and-safety-menu" className="sectionFormatting">
                            <h2> "HealthAndSafetyMenu"</h2>
                            <div id="end-user license agreement">
                                <p>These are the first menus the player sees when Poly Beats opens. So leave a good
                                    impression.
                                    <br></br>
                                    First menu seen when a new player opens is this:</p>
                                <h3>
                                    END-USER LICENSE AGREEMENT MENU</h3>
                                <div className="leftright-textimage-align">
                                    <img
                                        src={Images.eula_menu}
                                        style={{height: "293px", width: "520px"}}
                                        alt="EULA Menu"
                                    />
                                    <div>
                                        <h3>"What are the numbers and lines for?"</h3>
                                        <p>They're there so that you can visually see what you're changing with every
                                            property.
                                            With that, let's get into it.</p>
                                    </div>
                                </div>

                                <div className="property-array-align">
                                    <div>
                                        <h4>[1]</h4>
                                        <h3>PanelColor</h3>
                                        <p>This is used for the panel (the black square in the photo) that is behind the
                                            menu.
                                            <br></br>
                                            <span className="dimensionsText"> Default Color: #000000 </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[2]</h4>
                                        <h3>EULATitle_TextColor</h3>
                                        <p>This is the title near the top of the screen of the EULA menu.
                                            <br></br>
                                            <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[3]</h4>
                                        <h3>EULA_TextColor</h3>
                                        <p>This is the text box that yaps about the entire EULA to the player.
                                            <br></br>
                                            <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[4]</h4>
                                        <h3>EULA_ScrollbarBackingColor</h3>
                                        <p>The color of the little lines behind the scrollbar.
                                            <br></br>
                                            <span className="dimensionsText" style={{color: "#626262"}}> Default Color: #626262 </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[5]</h4>
                                        <h3>EULA_ScrollbarColor</h3>
                                        <p>The color of the actual thing the player scrolls (the pink thing in the
                                            photo).
                                            <br></br>
                                            <span className="dimensionsText" style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div id="leaderboard consent">

                                <div className="leftright-textimage-align">
                                    <img
                                        src={Images.nlc_menu}
                                        style={{height: "293px", width: "520px"}}
                                        alt="NLC Menu"
                                    />
                                    <h3>LEADERBOARD CONSENT MENU</h3>
                                </div>

                                <div className="property-array-align">
                                    <div>
                                        <p>[1 - Already Done]</p>
                                    </div>
                                    <div>
                                        <h4>[2]</h4>
                                        <h3>NLCTitle_TextColor</h3>
                                        <p>This is the title near the top of the screen of the NLC menu.
                                            <br></br>
                                            <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[3]</h4>
                                        <h3>NLC_TextColor</h3>
                                        <p>This is the text box that tells the player how the Leaderboard stuff works -
                                            and
                                            how their data is gonna be used for it.
                                            <br></br>
                                            <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[4]</h4>
                                        <h3>NLC_ScrollbarBackingColor</h3>
                                        <p>The color of the little lines behind the scrollbar.
                                            <br></br>
                                            <span className="dimensionsText" style={{color: "#626262"}}> Default Color: #626262 </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[5]</h4>
                                        <h3>NLC_ScrollbarColor</h3>
                                        <p>The color of the actual thing the player scrolls (the pink thing in the
                                            photo).
                                            <br></br>
                                            <span className="dimensionsText" style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div id="health and safety">
                                <div className="leftright-textimage-align">
                                    <img
                                        src={Images.hs_menu}
                                        style={{height: "293px", width: "520px"}}
                                        alt="H&S Menu"
                                    />
                                    <h3>HEALTH AND SAFETY MENU</h3>
                                </div>

                                <div className="property-array-align">
                                    <div>
                                        <p>[1 - Already Done]</p>
                                    </div>
                                    <div>
                                        <h4>[2]</h4>
                                        <h3>HealthAndSafetyTitle_TextColor</h3>
                                        <p>This is the title near the top of the screen of the Health and Safety menu.
                                            <br></br>
                                            <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[3]</h4>
                                        <h3>HealthAndSafety_TextColor</h3>
                                        <p>This is the text box that yaps about the Health and Safety stuff to the
                                            player.
                                            <br></br>
                                            <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[4]</h4>
                                        <h3>HealthAndSafety_ScrollbarColor</h3>
                                        <p>The color of the little lines behind the scrollbar.
                                            <br></br>
                                            <span className="dimensionsText" style={{color: "#626262"}}> Default Color: #626262 </span>
                                        </p>
                                    </div>
                                    <div>
                                        <h4>[5]</h4>
                                        <h3>HealthAndSafety_ScrollbarBackingColor</h3>
                                        <p>The color of the actual thing the player scrolls (the pink thing in the
                                            photo).
                                            <br></br>
                                            <span className="dimensionsText" style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div id="prompt-object-menu" className="sectionFormatting">
                            <h2>"PromptObjectMenu"</h2>
                            <p>This is shown to players when an error occurs, when they want to report somebody, or
                                for...
                                well, really anything that needs the player's immediate attention.</p>
                            <p>So, there's three types of Prompt Menus:
                                <br></br> - "Normal" (which only shows one button that says "Ok", or something)
                                <br></br> - "Option" (which shows two buttons, usually saying "Yes" and "No", like
                                below)
                                <br></br> - "Input" (which shows an input field, plus a button - it's rare to find
                                though)
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.normal_prompt_menu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Normals.png!"
                                />
                                <div>
                                    <h3>Prompt Menu ["Option" Type]</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>PromptSprite_Color</h3>
                                    <p>This is the thing that holds all the text and buttons of the prompt (it's the
                                        lighter
                                        grey thing in the picture.)
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#7D7D7D"}}> Default Color: #7D7D7D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>TitleText_Color</h3>
                                    <p>This is the title near the top of the screen of the Prompt.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>DescriptionText_Color</h3>
                                    <p>This is where the majority of the prompt's information is given to the player.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <p>The next few variables are for prompts that are REALLY rare, but can happen. Look:</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.input_prompt_menu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Input.png!"
                                />
                                <div>
                                    <h3>Prompt Menu ["Input" Type]</h3>
                                </div>
                            </div>
                            <p>we've done [1], [2], [3] & [4], so let's do the next 3.</p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>InputPrompt_InputFieldColor</h3>
                                    <p>This is the color used for the input field. The input field has an outline that
                                        is
                                        grey usually, so make sure your color can complement it.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>InputPrompt_InputFieldPlaceholderTextColor</h3>
                                    <p>This is the color of the text that's slightly faded, which shows when the player
                                        hasn't written anything. (In this case, the text in the image).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #323232 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>InputPrompt_InputFieldTextColor</h3>
                                    <p>This is the color of the text that the player has actually written inside the
                                        input
                                        field.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="transition-manager-menu" className="sectionFormatting">
                            <h2>"TransitionManagerMenu"</h2>
                            <p>This is the screen you either see all the time because your computer is slow as heck, or
                                the
                                one that comes and goes insanely fast, before you have time to process anything. Either
                                way,
                                it's important to have in a video game. Here's how to make yours.</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.transition_menu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Normals.png!"
                                />
                                <div>
                                    <h3>Transition Screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>Picture_Color</h3>
                                    <p>This is the color used for the photo shown on the screen. You can change the
                                        image
                                        file, but we'll deal with that later in the guide.
                                        <br></br>You'll probably want to keep this consistent throughout the rest of
                                        your
                                        theme, as this is now going to be the "Accent Color" of your theme.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Foreground_DropshadowColor</h3>
                                    <p>This is the color of the bottom holder that holds all of the other stuff on the
                                        screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Fact_TextColor</h3>
                                    <p>This is the color of the text that's shown in the bottom left of the screen. It
                                        has
                                        random messages and phrases that goes on it.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>FifthStepGames_LogoColor</h3>
                                    <p>This is the logo for our studio, 5th Step Games, and also the Poly Beats
                                        typography.
                                        You'll most likely wanna change this if your Foreground Dropshadow Color is not
                                        a
                                        dark color.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>LoadingBar_Color</h3>
                                    <p>This is the star of the show, and it animates. It slides across the screen left
                                        to
                                        right.
                                        You'll wanna change this if your Foreground Dropshadow is not a dark color.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="main-menu" className="sectionFormatting">
                            <h2>"MainMenu"</h2>
                            <p>This is the Main Menu of the game. It's super important to keep this colorful for the
                                player.
                                <br></br>It's quite complex to visualize, so we'll show them in "layers". First, we'll
                                deal
                                with the actual background behind all the text.</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.mainmenu_layer1}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Menu Layer 1.png!"
                                />
                                <div>
                                    <h3>Main Menu - Layer 1 (the important stuff)</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>TopLeft_StreakColor</h3>
                                    <p>This is the color for the "streak" coming from the top left of the screen into
                                        the
                                        hexagon (middle pentagon)
                                        <br></br>You'll probably want to keep this consistent throughout the rest of
                                        your
                                        theme, as this is now going to be the "Accent Color" of your theme.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>TopLeft_StreakHighlightedColor</h3>
                                    <p>This is the color the streak gets layered with when hovered over.
                                        <br></br><br></br>
                                        I'd strongly suggest you make this the same color as the streak color you went
                                        with,
                                        just to make it brighter on hover.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>TopRight_StreakColor</h3>
                                    <p>This is the color for the "streak" coming from the top right of the screen into
                                        the
                                        hexagon (middle pentagon)
                                        <br></br>You'll probably want to keep this consistent throughout the rest of
                                        your
                                        theme, as this is now going to be the "Accent Color" of your theme.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>TopRight_StreakHighlightedColor</h3>
                                    <p>This is the color the streak gets layered with when hovered over.
                                        <br></br><br></br>
                                        I'd strongly suggest you make this the same color as the streak color you went
                                        with,
                                        just to make it brighter on hover.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>BottomRight_StreakColor</h3>
                                    <p>This is the color for the "streak" coming from the bottom right of the screen
                                        into
                                        the
                                        hexagon (middle pentagon)
                                        <br></br>You'll probably want to keep this consistent throughout the rest of
                                        your
                                        theme, as this is now going to be the "Accent Color" of your theme.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>BottomRight_StreakHighlightedColor</h3>
                                    <p>This is the color the streak gets layered with when hovered over.
                                        <br></br><br></br>
                                        I'd strongly suggest you make this the same color as the streak color you went
                                        with,
                                        just to make it brighter on hover.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Pedestal_StreakColor</h3>
                                    <p>This is the color for the "pedestal" - the streak coming out of the bottom center
                                        of
                                        the screen into the
                                        hexagon (middle pentagon)
                                        <br></br>You'll probably want to keep this consistent throughout the rest of
                                        your
                                        theme, as this is now going to be the "Accent Color" of your theme.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Pedestal_StreakHighlightedColor</h3>
                                    <p>This is the color the pedestal gets layered with when hovered over.
                                        <br></br><br></br>
                                        I'd strongly suggest you make this the same color as the streak color you went
                                        with,
                                        just to make it brighter on hover.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[9]</h4>
                                    <h3>BottomLeft_StreakColor</h3>
                                    <p>This is the color for the "streak" coming from the bottom left of the screen into
                                        the
                                        hexagon (middle pentagon)
                                        <br></br>You'll probably want to keep this consistent throughout the rest of
                                        your
                                        theme, as this is now going to be the "Accent Color" of your theme.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>BottomLeft_StreakHighlightedColor</h3>
                                    <p>This is the color the streak gets layered with when hovered over.
                                        <br></br><br></br>
                                        I'd strongly suggest you make this the same color as the streak color you went
                                        with,
                                        just to make it brighter on hover.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F60152"}}> Default Color: #F60152 </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.mainmenu_layer2}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Menu Layer 2.png!"
                                />
                                <div>
                                    <h3>Main Menu - Layer 2 (the actual UI)</h3>
                                    <p>This might look pretty confusing at first, but don't worry. You'll get it with
                                        time.</p>
                                </div>
                            </div>
                            <div>
                                <h4>[1]</h4>
                                <h3>PlainBlack_PictureColor</h3>
                                <p>This is the color of the black background with the lights coming out the top and
                                    shapes around the screen.
                                    <br></br>You're most likely gonna keep this at #FFFFFF (white) unless you load a
                                    custom PlainBlack image that needs coloring.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div className="property-array-align">

                                <div>
                                    <h4>[2]</h4>
                                    <h3>Freeplay_TextColor</h3>
                                    <p>The color of the text that appears on the top-left streak - the "Freeplay" text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Multiplayer_TextColor</h3>
                                    <p>The color of the text that appears on the top-right streak - the "Multiplayer"
                                        text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Settings_TextColor</h3>
                                    <p>The color of the text that appears on the bottom-right streak - the "Settings"
                                        text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Username_TextColor</h3>
                                    <p>The color of the text that appears on the pedestal streak - it either shows your
                                        username, or "Log In".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Noticeboard_TextColor</h3>
                                    <p>The color of the text inside the noticeboard button - the "Noticeboard" text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Quit_TextColor</h3>
                                    <p>The color of the text that appears on the bottom-left streak - the "Quit" text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">

                                <div>
                                    <h4>[8]</h4>
                                    <h3>Freeplay_SpriteColor</h3>
                                    <p>The color of the icon that appears on the top-left streak - the "Freeplay" icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Multiplayer_SpriteColor</h3>
                                    <p>The color of the icon that appears on the top-right streak - the "Multiplayer"
                                        icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>Settings_SpriteColor</h3>
                                    <p>The color of the icon that appears on the bottom-right streak - the "Settings"
                                        icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>Username_SpriteColor</h3>
                                    <p>The color of the icon that appears on the pedestal streak - it either shows your
                                        account profile picture, or a placeholder person (in the image above).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[12]</h4>
                                    <h3>Noticeboard_SpriteColor</h3>
                                    <p>The color of the noticeboard button.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>Quit_SpriteColor</h3>
                                    <p>The color of the icon that appears on the bottom-left streak - the "Quit" icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">

                                <div>
                                    <h4>[14]</h4>
                                    <h3>Hexagon_Color</h3>
                                    <p>The color of the center "hexagon" (we call pentagons, hexagons, in this game,
                                        don't
                                        mind us).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#F4004F"}}> Default Color: #F4004F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>PolyBeats_TitleColor</h3>
                                    <p>The color of the "POLY BEATS" title in the middle of the hexagon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[16]</h4>
                                    <h3>Version_TitleColor</h3>
                                    <p>The color of the game version text, in the top left of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>FifthStepGames_LogoColor</h3>
                                    <p>The color of the our studio's square logo - this is different from the Transition
                                        Manager Menu's logo.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <p>The next 2 values are BOOLEANS. These are either true or false variables, and have the
                                format:<br></br>
                                <code>"property name": true/false </code>
                            </p>
                            <div className="property-array-align">

                                <div>
                                    <h4>[18]</h4>
                                    <h3>AnimateMenuShapes</h3>
                                    <p>This decides whether you want the menu shapes to animate themselves flying around
                                        the
                                        environment
                                        <br></br>
                                        <span className="dimensionsText"> Default Value: true </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>ShowPoly</h3>
                                    <p>This decides whether you want our cute little mascot in the menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Value: true </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="song-selection" className="sectionFormatting">
                            <h2>"SongSelection"</h2>
                            <p>This is the probably the most used menu in Poly Beats, and as such, it's the most packed
                                - so
                                we've split it into 3 layers for your convenience, however each of them show different
                                scenarios.
                                <br></br>Just follow along, you'll be fine.<br></br></p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.songselect_layer1}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Song Selector Layer 1.png!"
                                />
                                <div>
                                    <h3>Song Selector - Layer 1 (Selector + Tune Pack Picker)</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>ChartmapBank_Color</h3>
                                    <p>This is the color of the big rectangle to the left of the screen, that holds all
                                        the
                                        chartmaps in a Tune Pack.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>ChartmapBank_UnzippingTitleTextColor</h3>
                                    <p>This is the color of the text shown when loading a Tune Pack. This shouldn't
                                        actually
                                        ever be shown, it's rare, but it could happen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>ChartmapBank_UnzippingTipText</h3>
                                    <p>This is the little piece of text shown underneath the "UNZIPPING MAPS..." text.
                                        It
                                        can be utilized as a cool easter egg if you want.
                                        <br></br>Keep it short.
                                        <br></br>This can be inserted into your array like so:
                                        <code>"ChartmapBank_UnzippingTipText": "This should be a one time thing for this
                                            tune pack."</code>
                                        <br></br>
                                        <span className="dimensionsText"> Value: "This should be a one time thing for this tune pack."</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ChartmapBank_UnzippingTipTextColor</h3>
                                    <p>This is the color of the text shown below the "UNZIPPING MAPS..." text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>ChartmapBank_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the Chartmap Bank's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>ChartmapBank_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing, to the left of
                                        the
                                        Chartmap Bank).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>ChartmapBank_ShowLoadingCircle</h3>
                                    <p>This decides whether you want to see the loading circle while unzipping maps.
                                        I <b><u>STRONGLY </u></b>
                                        suggest you leave this on, so users know if their game is having performance
                                        issues
                                        while loading maps.
                                        <br></br>
                                        <span className="dimensionsText"> Default Value: true </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[8]</h4>
                                    <h3>FreePacks_CategoryColor</h3>
                                    <p>This is the color of the widget above the free tune packs in game.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>FreePacks_CategoryTextColor</h3>
                                    <p>This is the color of the text that says "FREE PACKS".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>PaidPacks_CategoryColor</h3>
                                    <p>This is the color of the widget above the tune packs you paid for.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>PaidPacks_CategoryTextColor</h3>
                                    <p>This is the color of the text that says "PAID PACKS".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[12]</h4>
                                    <h3>TunePack_NormalColor</h3>
                                    <p>This is the color of a Tune Pack's button when it's not highlighted.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>TunePack_HighlightedColor</h3>
                                    <p>This is the color of a Tune Pack's button when it's highlighted by the mouse, or
                                        a
                                        controller cursor.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#8E9AAE"}}> Default Color: #8E9AAE </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>TunePack_SelectedColor</h3>
                                    <p>This is the color of a Tune Pack's button when it's been clicked by the mouse, or
                                        a
                                        controller cursor.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#5B7AAA"}}> Default Color: #5B7AAA </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>TunePack_TextColor</h3>
                                    <p>This is the color of a Tune Pack button's text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <p>The next 2 labels are for an object that's invisible in-game for now. <br></br> This is
                                because we haven't released any paid Tune Packs (and even if we did, you'd need to get a
                                few
                                to make it visible), nor have gained a big enough catalog of Tune Packs yet to show to
                                the
                                player. <br></br> When
                                they do, you'll start to see it.</p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[16]</h4>
                                    <h3>TunePacks_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the Tune Pack selector's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>TunePacks_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing, to the left of
                                        the
                                        Tune Pack selector).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <p>The "Docker" is the area where a lot of map info is condensed once you click a map. It's
                                a
                                gateway to the modifier options, practice mode menu, and allows you to select the
                                difficulty
                                to play.</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.songselect_layer2}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Song Selector Layer 2.png!"
                                />
                                <div>
                                    <h3>Song Selector - Layer 2 ("Docker")</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>Docker_Color</h3>
                                    <p>This is the color of the actual docker itself.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[2]</h4>
                                    <h3>LearnButton_Color</h3>
                                    <p>This is the color of the button to the right of the play button (it's how you
                                        access
                                        the practice mode menu).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#BC0052"}}> Default Color: #BC0052 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>LearnButton_TextColor</h3>
                                    <p>This is the color of the Learn button's text, which says "LEARN".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ModifierButton_Color</h3>
                                    <p>This is the color of the button to the left of the play button (it's how you
                                        access
                                        the modifier menu).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#BC0052"}}> Default Color: #BC0052 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>ModifierButton_TextColor</h3>
                                    <p>This is the color of the Modifier button's text, which says "MODIFIERS".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span></p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>PlayButton_Color</h3>
                                    <p>This is the color of the play button - the center button.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006F"}}> Default Color: #FF006F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>PlayButton_TextColor</h3>
                                    <p>This is the color of the Play button's text, which says "PLAY".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span></p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Difficulty_NormalColor</h3>
                                    <p>This is the color of a difficulty button when it's not highlighted.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Difficulty_HighlightedColor</h3>
                                    <p>This is the color of a difficulty button when it's highlighted by the mouse, or a
                                        controller cursor.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>Difficulty_SelectedColor</h3>
                                    <p>This is the color of a difficulty button when it's been clicked by the mouse, or
                                        a
                                        controller cursor.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FA066A"}}> Default Color: #FA066A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>Difficulty_TextColor</h3>
                                    <p>This is the color of a difficulty button's text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[12]</h4>
                                    <h3>DifficultySelector_Color</h3>
                                    <p>This is the color of the white chopped thingy that shows you what difficulty you
                                        selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[14]</h4>
                                    <h3>SongInfo_ArtistTextColor</h3>
                                    <p>This is the color of the text that shows a map's artist, if one is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[-> 15]</h4>
                                    <h3>SongInfo_MapperTextColor</h3>
                                    <p>This is the color of the text that shows who mapped the map that is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13 ->]</h4>
                                    <h3>PickMap_TextColor</h3>
                                    <p>This is the color of the text that is shown when a map is not selected yet.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[16]</h4>
                                    <h3>SongInfo_NPSTextColor</h3>
                                    <p>This is the color of the text that shows how many NPS (notes per second) on
                                        average,
                                        is thrown at the player during a play, if a map is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>SongInfo_NotesTextColor</h3>
                                    <p>This is the color of the text that shows how many notes are in a map, if one is
                                        selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[18]</h4>
                                    <h3>SongInfo_PolysTextColor</h3>
                                    <p>This is the color of the text that shows how many Polys (it's equivalent to "Star
                                        Difficulty" in osu!) a player would be playing at on a map, if one is selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF88D9"}}> Default Color: #FF88D9 </span>
                                    </p>
                                </div>

                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <p>In this layer, we tackle the Navigation menu, and Song Buttons.
                                <br></br>
                                The Navigation menu is just that, a navigation menu that lets the player go to different
                                parts of the menu, quickly.
                                <br></br>
                                A song button is how the player picks a map, so make sure it is attention grabbing but
                                not
                                too obnoxious as numerous (usually) appear at a time.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.songselect_layer3}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Song Selector Layer 3.png!"
                                />
                                <div>
                                    <h3>Song Selector - Layer 3 (Navigation + Song Buttons)</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>SongButton_Color</h3>
                                    <p>This is the color of the song button. It's affected by Bloom, so don't make it
                                        too
                                        bright.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#91B9FF"}}> Default Color: #91B9FF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>SongButton_TitleTextColor</h3>
                                    <p>This is the color of the text that shows the name of the map, in the song button.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>SongButton_ArtistTextColor</h3>
                                    <p>This is the color of the text that shows the song artist of the map, in the song
                                        button.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>SongButton_MapperTextColor</h3>
                                    <p>This is the color of the text that shows the name of the mapper who mapped the
                                        song
                                        in the song button.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>SongButton_SongLengthTextColor</h3>
                                    <p>This is the color of the text that shows how long the song in the song button is.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Navigation_Color</h3>
                                    <p>This is the color of the Navigation menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Navigation_TitleColor</h3>
                                    <p>This is the color of the text above all the buttons that says "NAVIGATION".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>


                        </div>
                        <div id="leaderboards-menu" className="sectionFormatting">
                            <h2>"Leaderboards"</h2>
                            <p>This is a small part of the Song Selection menu, which keeps things competitive.
                                <br></br>It's also quite packed, so keep up.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.leaderboards}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Leaderboard Menus.png!"
                                />
                                <div>
                                    <h3>Leaderboard Menus. Left side deals with the actual board, right side deals with
                                        player rankings</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>Leaderboard_Color</h3>
                                    <p>This is used for the panel that holds all the player scores.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Leaderboard_LoadingTitleTextColor</h3>
                                    <p>This is the color of the text that is shown when loading a leaderboard.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Leaderboard_LoadingTipText</h3>
                                    <p>This is the text shown when loading a leaderboard.
                                        <br></br>
                                        <span className="dimensionsText"> Value: "Steam really needs to make their API better."</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Leaderboard_LoadingTipTextColor</h3>
                                    <p>This is the color of the Text Tip for the leaderboard's loading screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Leaderboard_ShowLoadingCircle</h3>
                                    <p>This decides whether you want to see the loading circle while unzipping maps.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Leaderboard_NoScoresFoundTitleTextColor</h3>
                                    <p>This is the color of the text that is shown when a leaderboard returns no scores.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Leaderboard_NoScoresFoundTipText</h3>
                                    <p>This is the text shown when loading a leaderboard.
                                        <br></br>
                                        <span className="dimensionsText"> Value: "There are no scores available to be fetched, But you could be the first to set a high score."</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Leaderboard_NoScoresFoundTipTextColor</h3>
                                    <p>This is the color of the Text Tip for the leaderboard's "no scores" screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <p>"Filters" are the top 3 buttons that let the player see scores from everyone (Global),
                                people
                                around the scores they got (AroundMe), and scores in their little bubble
                                (JustFriends)<br></br></p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Filters_GlobalNormalColor</h3>
                                    <p>This is the color of the "Global" filter button when it's not selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006F"}}> Default Color: #FF006F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>Filters_GlobalSelectedColor</h3>
                                    <p>This is the color of the "Global" filter button when it's currently selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#5B7AAA"}}> Default Color: #5B7AAA</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>Filters_GlobalSpriteColor</h3>
                                    <p>This is the color of the "Global" filter button's image (which is a Wireframe of
                                        a
                                        globe).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[12]</h4>
                                    <h3>Filters_AroundMeNormalColor</h3>
                                    <p>This is the color of the "Global" filter button when it's not selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006F"}}> Default Color: #FF006F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>Filters_AroundMeSelectedColor</h3>
                                    <p>This is the color of the "Around Me" filter button when it's currently selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#5B7AAA"}}> Default Color: #5B7AAA</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>Filters_AroundMeSpriteColor</h3>
                                    <p>This is the color of the "Around Me" filter button's image (which is a line
                                        sketch of
                                        a singular person).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[15]</h4>
                                    <h3>Filters_JustFriendsNormalColor</h3>
                                    <p>This is the color of the "Just Friends" filter button when it's not selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006F"}}> Default Color: #FF006F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[16]</h4>
                                    <h3>Filters_JustFriendsSelectedColor</h3>
                                    <p>This is the color of the "Just Friends" filter button when it's currently
                                        selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#5B7AAA"}}> Default Color: #5B7AAA</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>Filters_JustFriendsSpriteColor</h3>
                                    <p>This is the color of the "Just Friends" filter button's image (which is a line
                                        sketch
                                        of
                                        3 faces).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <p>Now, "Types" are the bottom 3 buttons that let the player see leaderboards of different
                                types.
                                There are three types, Score, Combo, and Skill Points.<br></br></p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[18]</h4>
                                    <h3>Types_ScoreNormalColor</h3>
                                    <p>This is the color of the "Score" type button when it's not selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006F"}}> Default Color: #FF006F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>Types_ScoreSelectedColor</h3>
                                    <p>This is the color of the "Score" type button when it's currently selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#5B7AAA"}}> Default Color: #5B7AAA</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[20]</h4>
                                    <h3>Types_ScoreTextColor</h3>
                                    <p>This is the color of the "Score" type text's color.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[21]</h4>
                                    <h3>Types_ComboNormalColor</h3>
                                    <p>This is the color of the "Combo" type button when it's not selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006F"}}> Default Color: #FF006F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[22]</h4>
                                    <h3>Types_ComboSelectedColor</h3>
                                    <p>This is the color of the "Combo" type button when it's currently selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#5B7AAA"}}> Default Color: #5B7AAA</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[23]</h4>
                                    <h3>Types_ComboTextColor</h3>
                                    <p>This is the color of the "Combo" type text's color.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[24]</h4>
                                    <h3>Types_SkillPointsNormalColor</h3>
                                    <p>This is the color of the "Skill Points" type button when it's not selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006F"}}> Default Color: #FF006F </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[25]</h4>
                                    <h3>Types_SkillPointsSelectedColor</h3>
                                    <p>This is the color of the "Skill Points" type button when it's currently selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#5B7AAA"}}> Default Color: #5B7AAA</span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[26]</h4>
                                    <h3>Types_SkillPointsTextColor</h3>
                                    <p>This is the color of the "Skill Points" type text's color.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[27]</h4>
                                    <h3>Leaderboard_WidgetToggleColor</h3>
                                    <p>This is the color of the button in the center of the types and filters
                                        <br></br>that let the player decide whether to open or close Leaderboards.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #3D3D3D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[28]</h4>
                                    <h3>Leaderboard_WidgetToggleColor</h3>
                                    <p>This is the color of the actual arrow on the widget button.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[29]</h4>
                                    <h3>Leaderboard_PlayerPlaceRankColor</h3>
                                    <p>This is the color of a player's rank (it's the left-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[30]</h4>
                                    <h3>Leaderboard_PlayerPlacePlayerNameColor</h3>
                                    <p>This is the color of a player's name (it's the center-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[31]</h4>
                                    <h3>Leaderboard_PlayerPlaceScoreColor</h3>
                                    <p>This is the color of a player's score (it's the right-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[32]</h4>
                                    <h3>Me_LeaderboardScoreColor</h3>
                                    <p>This is the color of the local player (the actual player playing)'s rank (it's
                                        the
                                        left-most piece of text in a Ranking).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF5FA5"}}> Default Color: #FF5FA5</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[33]</h4>
                                    <h3>Me_LeaderboardPlayerNameColor</h3>
                                    <p>This is the color of the local player (the actual player playing)'s name (it's
                                        the
                                        center-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF5FA5"}}> Default Color: #FF5FA5</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[34]</h4>
                                    <h3>Me_LeaderboardScoreColor</h3>
                                    <p>This is the color of the local player (the actual player playing)'s score (it's
                                        the
                                        right-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF5FA5"}}> Default Color: #FF5FA5</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[35]</h4>
                                    <h3>Leaderboard_ScrollbarColor</h3>
                                    <p>The color of the little lines behind the leaderboard's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[36]</h4>
                                    <h3>Leaderboard_ScrollbarBackingColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="modifiers-menu" className="sectionFormatting">
                            <h2>"ModifiersMenu"</h2>
                            <p>This is a menu that lets the player pick what modifiers they want to play their game with
                                -
                                it makes things interesting, keeps things challenging, or not, if they want to play a
                                map
                                with helpers.
                                <br></br>
                                This menu is basically parallel to the Settings Menu, so you probably wanna keep the
                                color
                                settings you have here, onto the Settings menu.
                                <br></br><br></br>
                                I'm gonna show you one of the modifier pages, and we'll design our theme around it.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.modifiersmenu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Modifiers Menu - "Helper Mods" screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the big text that shows the premise of the menu in the
                                        top-left
                                        of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>MenuDescriptionText_Color</h3>
                                    <p>This is the text underneath the Menu Title, typically shows a little quip.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Multiplier_TextColor</h3>
                                    <p>This is the color of the text that shows how much score you're gonna gain per
                                        note,
                                        or block (hold note) hit.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Attribute_TitleTextColor</h3>
                                    <p>This is the title text color of a modifier.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Attribute_DescriptionTextColor</h3>
                                    <p>This is the description of a modifier.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>MultiplierPercentagePositive_TextColor</h3>
                                    <p>This is the color that shows on some modifier info text (below the title of the
                                        modifier), when the modifier gives a multiplier increase.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#00FF00"}}> Default Color: #00FF00 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>MultiplierPercentageNegative_TextColor</h3>
                                    <p>This is the color that shows on some modifier info text (below the title of the
                                        modifier), when the modifier gives a multiplier decrease.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0043"}}> Default Color: #FF0043 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Attribute_ToggleOnColor</h3>
                                    <p>This is the color of a modifier's toggle, that is shown when it's on.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006A"}}> Default Color: #FF006A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>Attribute_ToggleOffColor</h3>
                                    <p>This is the color of a modifier's toggle, that is shown when it's off.
                                        <br></br>It can be the
                                        same as the ToggleOnColor, since it'll be on a sprite that has a lot of
                                        transparency
                                        anyway.<br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006A"}}> Default Color: #FF006A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>AttributeDivider_Color</h3>
                                    <p>This is a color of a "divider" (the line below each modifier). <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[12]</h4>
                                    <h3>Modifiers_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the menu's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>Modifiers_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>Attribute_ContentsScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind a modifier setting's scrollbar. (invisible
                                        since
                                        none of them use them right now).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>Attribute_ContentsScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="settings-menu" className="sectionFormatting">
                            <h2>"SettingsMenu"</h2>
                            <p>This is a menu that allows the player to change anything about their game.
                                <br></br> Customization is paramount in Poly Beats, so make sure this menu is well-kept
                                and
                                not too obnoxious.
                                <br></br><br></br>
                                I'm gonna show you a sample of the menu with all possible setting types, just to keep
                                things
                                clear.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.settingsmenu_layer1}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Settings Menu - [Layer 1] Actual Settings</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the big text that shows the premise of the menu in the
                                        top-left
                                        of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>AttributeDivider_Color</h3>
                                    <p>This is a color of a "divider" (the line below each setting). <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Attribute_TitleTextColor</h3>
                                    <p>This is the title text color of a setting.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Attribute_DescriptionTextColor</h3>
                                    <p>This is the description of a setting.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Attribute_ToggleOnColor</h3>
                                    <p>This is the color of a setting's toggle, <br></br> that is shown when it's on.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006A"}}> Default Color: #FF006A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Attribute_ToggleOffColor</h3>
                                    <p>This is the color of a setting's toggle, <br></br> that is shown when it's off.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006A"}}> Default Color: #FF006A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Attribute_ToggleTextColor</h3>
                                    <p>This is a color of the text above an<br></br> individual toggle in a toggle
                                        group. <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Attribute_SliderBackingColor</h3>
                                    <p>This is the color of the slider's background color - it shows if the scrollbar
                                        isn't
                                        scrolled to be completely full.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525151 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>Attribute_SliderFillColor</h3>
                                    <p>This is the color of the slider's fill - it shows when the player scrolls the
                                        scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FA0165"}}> Default Color: #FA0165 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>Attribute_SliderTextColor</h3>
                                    <p>This is the color of the slider's text component - it shows what we're setting a
                                        new
                                        value too.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[11]</h4>
                                    <h3>Attribute_DropdownColor</h3>
                                    <p>This is the color of the background of a dropdown.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[12]</h4>
                                    <h3>Attribute_DropdownArrowColor</h3>
                                    <p>This is the color of a little arrow <br></br>
                                        in the center-left of the Dropdown display.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>Attribute_DropdownDisplayTextColor</h3>
                                    <p>This is the color of the text which shows the<br></br>
                                        currently selected option in the dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">

                                <div>
                                    <h4>[14]</h4>
                                    <h3>Attribute_ContentsScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>Attribute_ContentsScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind a setting's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[16]</h4>
                                    <h3>Attribute_DropdownContentsBackingColor</h3>
                                    <p>This is considerably invisible sometimes, but this is essentially the image that
                                        holds all the Dropdown options. <br></br>This
                                        property changes the color of that.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525051 </span>
                                    </p>
                                </div>

                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[17]</h4>
                                    <h3>Attribute_DropdownContentsItemColor</h3>
                                    <p>This is used for the color of an option's button in the Dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #383838 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[18]</h4>
                                    <h3>Attribute_DropdownContentsItemHexagonColor</h3>
                                    <p>This is the color of the little hexagon (we call pentagons, hexagons, in this
                                        game), <br></br>that acts like a "checkmark" to the currently selected option.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>Attribute_DropdownContentsItemTextColor</h3>
                                    <p>This is a color of the text that shows what the option is.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <p>This next layer is small, but it shows when the player change a keybind, so it's
                                important to
                                have it not be too distracting.</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.settingsmenu_layer2}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Settings Menu 2!.png!"
                                />
                                <div>
                                    <h3>Settings Menu - [Layer 2] Custom Keybinds Prompt</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>Attribute_KeybindPanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        "PRESS ANY KEY" text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Attribute_KeybindTextColor</h3>
                                    <p>This is the color of the text that tells you to "PRESS ANY KEY".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Settings_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the
                                        photo). <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Settings_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind a setting menu's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div id="report-menu" className="sectionFormatting">
                            <h2>"ReportMenu"</h2>
                            <p>This is a system that lets players send reports on bad actors to us directly. There's 4
                                menus
                                here, so we're gonna go through them, one by one.
                                <br></br>
                                This menu is basically parallel to the Settings Menu, so you probably wanna keep the
                                color
                                settings you have here, onto the Settings menu.
                                <br></br><br></br>
                                I'm gonna show you one of the modifier pages, and we'll design our theme around it.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.report_reason}
                                    style={{height: "175px", width: "550px"}}
                                    alt="Report Menu 1.png!"
                                />
                                <div>
                                    <h3>Report Menu - "Report Reason" screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Report_SpriteColor</h3>
                                    <p>This is the color of the grey object behind all the text and buttons, to keep
                                        them
                                        together.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#7D7D7D"}}> Default Color: #7D7D7D </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>ReportTitle_TextColor</h3>
                                    <p>This is the text at the top of the grey object showing who you're reporting.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ReportDescription_TextColor</h3>
                                    <p>This is the color of the text below the title.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Attribute_ToggleOnColor</h3>
                                    <p>This is the color of a reason's toggle, that is shown when it's on.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006A"}}> Default Color: #FF006A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Attribute_ToggleOffColor</h3>
                                    <p>This is the color of a reason's toggle, that is shown when it's off.
                                        <br></br>It can be the
                                        same as the ToggleOnColor, since it'll be on a sprite that has a lot of
                                        transparency
                                        anyway.<br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF006A"}}> Default Color: #FF006A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>ReasonAttribute_TextColor</h3>
                                    <p>This is the color of a reason's text. It shows a reason why a player wants to
                                        report
                                        a map.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">

                                <img
                                    src={Images.report_sending}
                                    style={{height: "167px", width: "550px"}}
                                    alt="Report Menu 2.png!"
                                />
                                <div>
                                    <h3>Report Menu - "Report Sending" screen</h3>
                                </div>
                            </div>
                            <div>
                                <h4>[1]</h4>
                                <h3>SendingReport_TextColor</h3>
                                <p>This is the color used for the text that shows you that your report is sending.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>

                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.report_sent}
                                    style={{height: "175px", width: "550px"}}
                                    alt="Report Menu 3.png!"
                                />
                                <div>
                                    <h3>Modifiers Menu - "Report Sent" screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>ReportSent_TextColor</h3>
                                    <p>This is used for the text that shows you that your report was sent.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>ThankYou_TextColor</h3>
                                    <p>This is the color of the text that thanks you for reporting. :3
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.report_error}
                                    style={{height: "160px", width: "550px"}}
                                    alt="Report Menu 4.png!"
                                />
                                <div>
                                    <h3>Modifiers Menu - "Report Error" screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>ErrorTitle_TextColor</h3>
                                    <p>This is used for the text that shows you that there was a problem sending your
                                        report.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>ErrorDescriptionText_Color</h3>
                                    <p>This is the color of the text that tells you why it didn't send, although for
                                        some
                                        reason most of the time it doesn't tell you why it didn't send. I'll fix that
                                        eventually.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>YouTried_TextColor</h3>
                                    <p>The color of text that thanks you for trying to report anyways. We appreciate the
                                        thought.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="environment-menu" className="sectionFormatting">
                            <h2>"EnvironmentMenu"</h2>
                            <p>This is a menu that allows the player to change the environment they play with.
                                <br></br> This menu is also basically parallel to the Settings Menu, so you probably
                                wanna
                                keep the color settings you have here, onto the Settings menu.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.environment_menu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Envrionment Menu.png!"
                                />
                                <div>
                                    <h3>Environment Menu</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the big text that shows the premise of the menu in the
                                        top-left
                                        of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>AttributeDivider_Color</h3>
                                    <p>This is a color of a "divider" (the line below each setting). <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Attribute_TitleTextColor</h3>
                                    <p>This is the title text color of a setting.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Attribute_DescriptionTextColor</h3>
                                    <p>This is the description text color of a setting.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Attribute_DropdownColor</h3>
                                    <p>This is the color of the background of a dropdown.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Attribute_DropdownDisplayTextColor</h3>
                                    <p>This is the color of the text which shows the<br></br>
                                        currently selected option in the dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Attribute_DropdownArrowColor</h3>
                                    <p>This is the color of a little arrow <br></br>
                                        in the center-left of the Dropdown display.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">

                                <div>
                                    <h4>[9]</h4>
                                    <h3>Attribute_ContentsScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>Attribute_ContentsScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind a setting's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>Attribute_DropdownContentsBackingColor</h3>
                                    <p>This is considerably invisible sometimes, but this is essentially the image that
                                        holds all the Dropdown options. <br></br>This
                                        property changes the color of that.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525051 </span>
                                    </p>
                                </div>

                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[12]</h4>
                                    <h3>Attribute_DropdownContentsItemColor</h3>
                                    <p>This is used for the color of an option's button in the Dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #383838 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>Attribute_DropdownContentsItemHexagonColor</h3>
                                    <p>This is the color of the little hexagon (we call pentagons, hexagons, in this
                                        game), <br></br>that acts like a "checkmark" to the currently selected option.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>Attribute_DropdownContentsItemTextColor</h3>
                                    <p>This is a color of the text that shows what the option is.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[15]</h4>
                                    <h3>EnvironmentPreview_TextColor</h3>
                                    <p>This is used on the text above an environment's preview image, which says
                                        "PREVIEW".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[16]</h4>
                                    <h3>EnvironmentMenu_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the
                                        photo). <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>EnvironmentMenu_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind a setting menu's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="custom-songs-menu" className="sectionFormatting">
                            <h2>"CustomSongsMenu"</h2>
                            <p>This is a menu that has a few functions that either lets the player download chartmaps
                                and
                                themes, or import their own from osu!
                                <br></br>
                                This menu is also basically parallel to the Settings Menu, so you probably wanna keep
                                the
                                color
                                settings you have here, onto the Settings menu.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.customs_menu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Custom Songs (Stuff) Screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the big text that shows the premise of the menu in the
                                        top-left
                                        of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>AttributeDivider_Color</h3>
                                    <p>This is a color of a "divider" (the line below each function). <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Attribute_TitleTextColor</h3>
                                    <p>This is the title text color of a modifier.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Attribute_DescriptionTextColor</h3>
                                    <p>This is the description of a modifier.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="marketplace-menu" className="sectionFormatting">
                            <h2>"MarketplaceMenu"</h2>
                            <p>This is probably the most complex menu in Poly Beats, and for good reason.
                                <br></br>
                                It lets players download chartmaps and Themes from custom sources, and also upload them.
                                <br></br>
                                There's about 4 layers to this, so let's just get into it.
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.marketplace_layer1a}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>The Marketplace's Homescreen.</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the big text that shows the premise of the menu in the
                                        top-left
                                        of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Searchbar_Color</h3>
                                    <p>This is the color used for the search bar. The search bar has an outline that is
                                        grey usually, so make sure your color can complement it.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Searchbar_PlaceholderTextColor</h3>
                                    <p>This is the color of the text that's slightly faded, which shows when the player
                                        hasn't written anything. (In this case, the text in the image).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #323232 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Searchbar_TextColor</h3>
                                    <p>This is the color of the text that the player has actually written inside the
                                        search
                                        bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[6]</h4>
                                    <h3>HomeTab_Color</h3>
                                    <p>This is the color of the Home icon on the top menu bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>HomeTab_TextColor</h3>
                                    <p>This is the color of the text above the Home icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>UploadTab_Color</h3>
                                    <p>This is the color of the Upload icon on the top menu bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>UploadTab_TextColor</h3>
                                    <p>This is the color of the text above the Upload icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>SearchTab_Color</h3>
                                    <p>This is the color of the Search icon, to the left, on the top menu bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>SearchTab_TextColor</h3>
                                    <p>This is the color of the text above the Search icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <p>Then we need to handle filters, these are used to find different types of content.</p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[12]</h4>
                                    <h3>Filters_GlobalColor</h3>
                                    <p>This is the color of the "Globe" icon in the filter bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>Filters_GlobalTextColor</h3>
                                    <p>This is the color of the text that says "GLOBAL".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>Filters_MostDownloadedColor</h3>
                                    <p>This is the color of the "Downloads" icon in the filter bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>Filters_MostDownloadedTextColor</h3>
                                    <p>This is the color of the text that says "MOST DOWNLOADED".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>

                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[16]</h4>
                                    <h3>Filters_LatestColor</h3>
                                    <p>This is the color of the "Latest" icon in the filter bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>Filters_LatestTextColor</h3>
                                    <p>This is the color of the text that says "LATEST".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[18]</h4>
                                    <h3>Filters_LevelsByFriendsColor</h3>
                                    <p>This is the color of the "Friends" icon in the filter bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>Filters_LevelsByFriendsTextColor</h3>
                                    <p>This is the color of the text that says "FRIEND LEVELS".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[20]</h4>
                                    <h3>Filters_MyLevelsColor</h3>
                                    <p>This is the color of the "Person" icon in the filter bar.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[21]</h4>
                                    <h3>Filters_MyLevelsTextColor</h3>
                                    <p>This is the color of the text that says "YOUR LEVELS".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[22]</h4>
                                    <h3>Home_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[23]</h4>
                                    <h3>Home_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.marketplace_layer1b}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Marketplace (Content Filter + Song Button) - Layer 2.</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>ContentFilter_TitleTextColor</h3>
                                    <p>This is the color of the text above the "Content Filter" dropdown that says
                                        "CONTENT
                                        TO LOAD".<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>ContentFilter_DropdownColor</h3>
                                    <p>This is the color of the background of the dropdown.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>ContentFilter_DropdownDisplayTextColor</h3>
                                    <p>This is the color of the text which shows the<br></br>
                                        currently selected option in the dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ContentFilter_DropdownArrowColor</h3>
                                    <p>This is the color of a little arrow <br></br>
                                        in the center-left of the Dropdown display.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>ContentFilter_DropdownContentsBackingColor</h3>
                                    <p>This is considerably invisible sometimes, but this is essentially the image that
                                        holds all the Dropdown options. <br></br>This
                                        property changes the color of that.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[6]</h4>
                                    <h3>ContentFilter_DropdownContentsItemColor</h3>
                                    <p>This is used for the color of an option's button in the Dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #383838 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>ContentFilter_DropdownContentsItemHexagonColor</h3>
                                    <p>This is the color of the little hexagon (we call pentagons, hexagons, in this
                                        game), <br></br>that acts like a "checkmark" to the currently selected option.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>ContentFilter_DropdownContentsItemTextColor</h3>
                                    <p>This is a color of the text that shows what the option is.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[9]</h4>
                                    <h3>SongButton_Color</h3>
                                    <p>This is the color of a Custom Chartmap when it's loaded into the
                                        Homescreen.<br></br>
                                        <span className="dimensionsText"> Default Color: #5F78A4 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>SongButton_DifficultyEasyColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "EZ".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>SongButton_DifficultyExpertColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "EX".
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#03FF00"}}> Default Color: #03FF00 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[12]</h4>
                                    <h3>SongButton_DifficultyLimitlessColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "LL".
                                        is thrown at the player during a play, if a map is selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#00D9FF"}}> Default Color: #00D9FF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>SongButton_DifficultyMaximumColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "MX".
                                        selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0055"}}> Default Color: #FF0055 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[14]</h4>
                                    <h3>SongButton_TitleTextColor</h3>
                                    <p>This is the color of the text that shows the name of the map.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>SongButton_ArtistTextColor</h3>
                                    <p>This is the color of the text that shows a map's artist, if one is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[16]</h4>
                                    <h3>SongButton_UploaderTextColor</h3>
                                    <p>This is the color of the text that shows who uploaded the map that is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[17]</h4>
                                    <h3>SongButton_MapIDInfoTextColor</h3>
                                    <p>This is the color of the text that is above the map's SteamID.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[18]</h4>
                                    <h3>SongButton_MapIDTextColor</h3>
                                    <p>This is the color of the text that shows the map's SteamID.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>SongButton_UploadDateInfoTextColor</h3>
                                    <p>This is the color of the text that is above the map's upload date.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[20]</h4>
                                    <h3>SongButton_UploadDateTextColor</h3>
                                    <p>This is the color of the text that shows the map's upload date.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[21]</h4>
                                    <h3>SongButton_VoteRatioInfoTextColor</h3>
                                    <p>This is the color of the text that is above the Vote Ratio slider.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[22]</h4>
                                    <h3>SongButton_VoteRatioSliderBackingColor</h3>
                                    <p>This is the color of the slider's background color - it shows if the scrollbar
                                        isn't
                                        scrolled to be completely full.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525151 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[23]</h4>
                                    <h3>SongButton_VoteRatioSliderFillColor</h3>
                                    <p>This is the color of the slider's fill - it shows when the player scrolls the
                                        scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FA0165"}}> Default Color: #FA0165 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[24]</h4>
                                    <h3>SongButton_VoteRatioSliderTextColor</h3>
                                    <p>This is the color of the slider's text component - it shows the upvote/downvote
                                        ratio
                                        of the map.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[25]</h4>
                                    <h3>SongButton_DownloadsInfoTextColor</h3>
                                    <p>This is the color of the text that shows the map's download count.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[26]</h4>
                                    <h3>SongButton_DownloadsColor</h3>
                                    <p>This is the color of the text that shows the "Download" icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.marketplace_layer1c}
                                    style={{height: "159px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Marketplace (Theme Button) - Layer 3.</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>ThemeButton_Color</h3>
                                    <p>This is the color of a Custom Theme when it's loaded into the
                                        Homescreen.<br></br>
                                        <span className="dimensionsText"> Default Color: #87034C </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[2]</h4>
                                    <h3>ThemeButton_TitleTextColor</h3>
                                    <p>This is the color of the text that shows the name of the Theme.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>ThemeButton_UploaderTextColor</h3>
                                    <p>This is the color of the text that shows a Theme's artist, if one is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ThemeButton_UploaderTextColor</h3>
                                    <p>This is the color of the text that shows who uploaded the Theme that is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>ThemeButton_ThemeIDInfoTextColor</h3>
                                    <p>This is the color of the text that is above the Theme's SteamID.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>ThemeButton_ThemeIDTextColor</h3>
                                    <p>This is the color of the text that shows the Theme's SteamID.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>ThemeButton_UploadDateInfoTextColor</h3>
                                    <p>This is the color of the text that is above the Theme's upload date.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>ThemeButton_UploadDateTextColor</h3>
                                    <p>This is the color of the text that shows the Theme's upload date.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[9]</h4>
                                    <h3>ThemeButton_VoteRatioInfoTextColor</h3>
                                    <p>This is the color of the text that is above the Vote Ratio slider.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>ThemeButton_VoteRatioSliderBackingColor</h3>
                                    <p>This is the color of the slider's background color - it shows if the scrollbar
                                        isn't
                                        scrolled to be completely full.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525151 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>ThemeButton_VoteRatioSliderFillColor</h3>
                                    <p>This is the color of the slider's fill - it shows when the player scrolls the
                                        scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FA0165"}}> Default Color: #FA0165 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[12]</h4>
                                    <h3>ThemeButton_VoteRatioSliderTextColor</h3>
                                    <p>This is the color of the slider's text component - it shows the upvote/downvote
                                        ratio
                                        of the Theme.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[13]</h4>
                                    <h3>ThemeButton_DownloadsInfoTextColor</h3>
                                    <p>This is the color of the text that shows the Theme's download count.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>ThemeButton_DownloadsColor</h3>
                                    <p>This is the color of the text that shows the "Download" icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.marketplace_layer2}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Marketplace (Upload Screen) - Layer 4.</h3>
                                    <p>Elements here are reused on the "Theme" version of this Upload page. We just
                                        don't
                                        use the input field colors, just the text colors.</p>

                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>Upload_ScreenTitleColor</h3>
                                    <p>This is the color of the title and slogan of the Upload menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Upload_MapTitleTitleTextColor</h3>
                                    <p>This is used for the text that says "MAP TITLE".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Upload_MapTitleInputFieldColor</h3>
                                    <p>This is the color used for the input field. The input field has an outline that
                                        is
                                        grey usually, so make sure your color can complement it.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Upload_MapTitleInputFieldPlaceholderTextColor</h3>
                                    <p>This is the color of the text that's slightly faded, which shows when the player
                                        hasn't written anything. (In this case, the text in the image).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #323232 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>Upload_MapTitleInputFieldTextColor</h3>
                                    <p>This is the color of the text that the player has actually written inside the
                                        input
                                        field.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Upload_MapDecriptionTitleTextColor</h3>
                                    <p>This is used for the text that says "MAP DESCRIPTION".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Upload_MapDescriptionInputFieldColor</h3>
                                    <p>This is the color used for the Description input field. The input field has an
                                        outline that is
                                        grey usually, so make sure your color can complement it.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Upload_MapDescriptionInputFieldPlaceholderTextColor</h3>
                                    <p>This is the color of the text that's slightly faded, which shows when the player
                                        hasn't written anything. (In this case, the text in the image).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #323232 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Upload_MapDescriptionInputFieldTextColor</h3>
                                    <p>This is the color of the text that the player has actually written inside the
                                        input
                                        field.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[10]</h4>
                                    <h3>UploadButton_Color</h3>
                                    <p>This is the color of the Upload icon at the bottom of the page.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>UploadButton_TextColor</h3>
                                    <p>This is the color of the text that says "UPLOAD" at the bottom of the page.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.marketplace_layer3}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Marketplace (Map Info Screen) - Layer 5.</h3>
                                    <p>Elements here are reused on the "Theme" version of this Upload page. We just
                                        don't
                                        use the input field colors, just the text colors.</p>

                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>MapInfoScreen_UploadDateInfoTextColor</h3>
                                    <p>This is the color of the text that is above the Map/Theme's upload date.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MapInfoScreen_UploadDateTextColor</h3>
                                    <p>This is the color of the text that shows the Map/Theme's upload date.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>MapInfoScreen_DownloadsInfoTextColor</h3>
                                    <p>This is the color of the text that shows the Map/Theme's download count.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>MapInfoScreen_DownloadsTextColor</h3>
                                    <p>This is the color of the text that shows the "Download" icon.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>MapInfoScreen_VoteRatioInfoTextColor</h3>
                                    <p>This is the color of the text that is above the Vote Ratio slider.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>MapInfoScreen_VoteRatioTextColor</h3>
                                    <p>This is the color of the text that shows the <br></br>upvote/downvote ratio
                                        of the Map/Theme.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <p>The next few fields are for Maps only.</p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[7]</h4>
                                    <h3>MapInfoScreen_DifficultiesInfoTextColor</h3>
                                    <p>This is the color of the text above the difficulties.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>MapInfoScreen_DifficultyEasyColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "EZ".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>MapInfoScreen_DifficultyExpertColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "EX".
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#03FF00"}}> Default Color: #03FF00 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>MapInfoScreen_DifficultyLimitlessColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "LL".
                                        is thrown at the player during a play, if a map is selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#00D9FF"}}> Default Color: #00D9FF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>MapInfoScreen_DifficultyMaximumColor</h3>
                                    <p>This is the color of the text in the top left of the map saying "MX".
                                        selected.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0055"}}> Default Color: #FF0055 </span>
                                    </p>
                                </div>
                            </div>
                            <p>Back to both of them now...</p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[12]</h4>
                                    <h3>MapInfoScreen_MapNameTextColor</h3>
                                    <p>This is the color of the text that shows the name of the Map/Theme.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>MapInfoScreen_ArtistTextColor</h3>
                                    <p>This is the color of the text that shows the Map/Theme's artist.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>MapInfoScreen_MapperTextColor</h3>
                                    <p>This is the color of the text that shows who made the Map/Theme that is selected.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>MapInfoScreen_DescriptionTextColor</h3>
                                    <p>This is the color of the text shows the long description of the Map/Theme.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[16]</h4>
                                    <h3>MapInfoScreen_DownloadButtonColor</h3>
                                    <p>This is the color of the Download button under the Map/Theme's Cover Art.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#00C2FF"}}> Default Color: #00C2FF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>MapInfoScreen_ReportButtonColor</h3>
                                    <p>This is the color of the Report button under the Map/Theme's Cover Art.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[18]</h4>
                                    <h3>MapInfoScreen_MapIDInfoTextColor</h3>
                                    <p>This is the color of the text that is above the Map/Theme's SteamID.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>MapInfoScreen_MapIDTextColor</h3>
                                    <p>This is the color of the text that shows the Map/Theme's SteamID.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[20]</h4>
                                    <h3>MapInfoScreen_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[21]</h4>
                                    <h3>MapInfoScreen_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.marketplace_layer4}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Marketplace ("Uploading" screen) - Layer 6.</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>Blocker_UploadingChartmapPanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that appears
                                        when <br></br>doing something in the Marketplace that takes time.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Blocker_UploadingChartmapTextColor</h3>
                                    <p>This is the color of the text that starts with "UPLOADING..."
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div id="practice-mode-menu" className="sectionFormatting">
                            <h2>"PracticeModeMenu"</h2>
                            <p>This is a menu that gives the player access to a few settings that makes practicing a
                                song
                                easier.
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.practice_menu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Modifiers Menu.png!"
                                />
                                <div>
                                    <h3>Practice Mode Screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the big text that shows the premise of the menu in the
                                        top-left
                                        of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>MenuDescription_TitleTextColor</h3>
                                    <p>This is the color of the text below the menu title.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[4]</h4>
                                    <h3>SongTime_TitleTextColor</h3>
                                    <p>This is the color of the text that says "Song Time".<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>SongTime_SliderBackingColor</h3>
                                    <p>This is the color of the slider's background color - it shows if the scrollbar
                                        isn't
                                        scrolled to be completely full.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525151 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>SongTime_SliderFillColor</h3>
                                    <p>This is the color of the slider's fill - it shows when the player scrolls the
                                        scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FA0165"}}> Default Color: #FA0165 </span>
                                    </p>
                                </div>

                                <div>
                                    <h4>[7]</h4>
                                    <h3>SongTime_SliderTextColor</h3>
                                    <p>This is the color of the slider's text component - it shows the time in the song
                                        we're skipping to.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[8]</h4>
                                    <h3>SongSpeed_TitleTextColor</h3>
                                    <p>This is the color of the text that says "Song Speed".<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>SongSpeed_SliderBackingColor</h3>
                                    <p>This is the color of the slider's background color - it shows if the scrollbar
                                        isn't
                                        scrolled to be completely full.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525151 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>SongSpeed_SliderFillColor</h3>
                                    <p>This is the color of the slider's fill - it shows when the player scrolls the
                                        scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FA0165"}}> Default Color: #FA0165 </span>
                                    </p>
                                </div>

                                <div>
                                    <h4>[11]</h4>
                                    <h3>SongSpeed_SliderTextColor</h3>
                                    <p>This is the color of the slider's text component - it shows the speed we're gonna
                                        play at.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="player-account-hub" className="sectionFormatting">
                            <h2>"PlayerAccountHub"</h2>
                            <p>This is a menu that is usually used for players to flex their global scores on
                                everyone,<br></br>so you can make this as flashy as you want, as they're typically
                                taking
                                screenshots of this page... regularly.
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.pah_layer1}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Player Account Hub.png!"
                                />
                                <div>
                                    <h3>The Player Account Hub</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the big text that shows the premise of the menu in the
                                        top-left
                                        of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>GlobalLeaderboards_BoardTitleTextColor</h3>
                                    <p>This is the color of the text above the global leaderboards, this text shows what
                                        leaderboard you're currently looking at - as it changes with the filters.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>PlayerCard_YourStatsTextColor</h3>
                                    <p>This is the color of the text above the Local Player's Card.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>PlayerCard_CountryTextColor</h3>
                                    <p>This is used for the text that tells you what country you're in (just to remind
                                        you,
                                        in case you didn't know).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>PlayerCard_UsernameTextColor</h3>
                                    <p>This is used for the text that shows your Steam Username.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>PlayerCard_SteamIDTextColor</h3>
                                    <p>This is used for the text that relays your Steam ID.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[8]</h4>
                                    <h3>PlayerCard_ScoreBackingColor</h3>
                                    <p>This is used for the image that holds the Score stats for the Local Player's
                                        Card.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#A1083A"}}> Default Color: #A1083A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>PlayerCard_ScoreTitleColor</h3>
                                    <p>This is used for the text that says "SCORE" in the Score stats holder.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>PlayerCard_ScoreTotalColor</h3>
                                    <p>This is used for the text that shows all the Score you've accumulated over time.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>PlayerCard_ScoreCountryRankTextColor</h3>
                                    <p>This is used for the text that shows how your total score compares to the rest of
                                        the
                                        country you're in.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[12]</h4>
                                    <h3>PlayerCard_ScoreGlobalRankTextColor</h3>
                                    <p>This is used for the text that shows how your total score compares to the rest of
                                        the
                                        Poly Beats playerbase.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[13]</h4>
                                    <h3>PlayerCard_ComboBackingColor</h3>
                                    <p>This is used for the image that holds the Score stats for the Local Player's
                                        Card.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#A1083A"}}> Default Color: #A1083A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>PlayerCard_ComboTitleColor</h3>
                                    <p>This is used for the text that says "BIGGEST COMBO" in the Score stats holder.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>PlayerCard_ComboTotalColor</h3>
                                    <p>This is used for the text that shows the largest combo streak you've ever held.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[16]</h4>
                                    <h3>PlayerCard_ComboCountryRankTextColor</h3>
                                    <p>This is used for the text that shows how your largest combo streak compares to
                                        the
                                        rest of the
                                        country you're in.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>PlayerCard_ComboGlobalRankTextColor</h3>
                                    <p>This is used for the text that shows how your largest combo streak compares to
                                        the
                                        rest of the
                                        Poly Beats playerbase.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[18]</h4>
                                    <h3>PlayerCard_SkillPointsBackingColor</h3>
                                    <p>This is used for the image that holds the Score stats for the Local Player's
                                        Card.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#A1083A"}}> Default Color: #A1083A </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>PlayerCard_SkillPointsTitleColor</h3>
                                    <p>This is used for the text that says "BIGGEST COMBO" in the Score stats holder.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[20]</h4>
                                    <h3>PlayerCard_SkillPointsTotalColor</h3>
                                    <p>This is used for the text that shows the largest combo streak you've ever held.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[21]</h4>
                                    <h3>PlayerCard_SkillPointsCountryRankTextColor</h3>
                                    <p>This is used for the text that shows how your largest combo streak compares to
                                        the
                                        rest of the
                                        country you're in.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[22]</h4>
                                    <h3>PlayerCard_SkillPointsGlobalRankTextColor</h3>
                                    <p>This is used for the text that shows how your largest combo streak compares to
                                        the
                                        rest of the
                                        Poly Beats playerbase.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[23]</h4>
                                    <h3>PlayerCard_BackingColor</h3>
                                    <p>This is used for the panel image behind all of your stats.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #004578 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[24]</h4>
                                    <h3>GlobalLeaderboards_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[25]</h4>
                                    <h3>GlobalLeaderboards_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[26]</h4>
                                    <h3>GlobalLeaderboards_PlayerPlaceBackingColor</h3>
                                    <p>This is the color of a Ranking's image that holds all the information about
                                        itself.<br></br>
                                        <span className="dimensionsText"> Default Color: #3A3A3A</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[27]</h4>
                                    <h3>GlobalLeaderboards_PlayerPlaceRankTextColor</h3>
                                    <p>This is the color of a player's rank (it's the left-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[28]</h4>
                                    <h3>GlobalLeaderboards_PlayerPlacePlayerNameTextColor</h3>
                                    <p>This is the color of a player's name (it's the center-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[29]</h4>
                                    <h3>GlobalLeaderboards_PlayerPlaceScoreTextColor</h3>
                                    <p>This is the color of a player's score (it's the right-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF</span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[30]</h4>
                                    <h3>GlobalLeaderboards_MeBackingColor</h3>
                                    <p>This is the color of the local player's Ranking's image that holds all the
                                        information about
                                        itself.<br></br>
                                        <span className="dimensionsText"> Default Color: #3A3A3A</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[31]</h4>
                                    <h3>GlobalLeaderboards_MeRankTextColor</h3>
                                    <p>This is the color of the local player (the actual player playing)'s rank (it's
                                        the
                                        left-most piece of text in a Ranking).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF5FA5"}}> Default Color: #FF5FA5</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[32]</h4>
                                    <h3>GlobalLeaderboards_MePlayerNameTextColor</h3>
                                    <p>This is the color of the local player (the actual player playing)'s name (it's
                                        the
                                        center-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF5FA5"}}> Default Color: #FF5FA5</span>

                                    </p>
                                </div>
                                <div>
                                    <h4>[33]</h4>
                                    <h3>GlobalLeaderboards_MeScoreTextColor</h3>
                                    <p>This is the color of the local player (the actual player playing)'s score (it's
                                        the
                                        right-most piece of text in a
                                        Ranking).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF5FA5"}}> Default Color: #FF5FA5</span>
                                    </p>
                                </div>
                            </div>
                            <p>The next two properties aren't utilized yet in this menu as there's really no need for
                                it,
                                but it's there just in-case it is, later. :3</p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[34]</h4>
                                    <h3>PlayerAccountHub_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the
                                        photo). <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[35]</h4>
                                    <h3>PlayerAccountHub_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the Player Account Hub menu's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <p>This next layer is just to show you how to control the filter dropdowns. They're handled
                                as
                                "Attributes" to keep them neat and uniform.</p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.pah_layer2}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Player Account Hub 2.png!"
                                />
                                <div>
                                    <h3>The second layer - just showing the filter dropdowns</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>Attribute_TitleTextColor</h3>
                                    <p>This is the color of the text above one of the dropdowns that shows what it's
                                        for.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Attribute_DropdownColor</h3>
                                    <p>This is the color of the background of a dropdown.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Attribute_DropdownDisplayTextColor</h3>
                                    <p>This is the color of the text which shows the<br></br>
                                        currently selected option in the dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Attribute_DropdownArrowColor</h3>
                                    <p>This is the color of a little arrow <br></br>
                                        in the center-left of the Dropdown display.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>

                            </div>
                            <div className="property-array-align">

                                <div>
                                    <h4>[5]</h4>
                                    <h3>Attribute_ContentsScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>Attribute_ContentsScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind a setting's scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>Attribute_DropdownContentsBackingColor</h3>
                                    <p>This is considerably invisible sometimes, but this is essentially the image that
                                        holds all the Dropdown options. <br></br>This
                                        property changes the color of that.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #525051 </span>
                                    </p>
                                </div>

                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Attribute_DropdownContentsItemColor</h3>
                                    <p>This is used for the color of an option's button in the Dropdown.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #383838 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Attribute_DropdownContentsItemHexagonColor</h3>
                                    <p>This is the color of the little hexagon (we call pentagons, hexagons, in this
                                        game), <br></br>that acts like a "checkmark" to the currently selected option.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[10]</h4>
                                    <h3>Attribute_DropdownContentsItemTextColor</h3>
                                    <p>This is a color of the text that shows what the option is.<br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div id="coming-soon-screen" className="sectionFormatting">
                            <h2>"ComingSoonScreen"</h2>
                            <p>This is a menu that is rarely shown, but only when we're working on something the player
                                can't know about, just yet. :3
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.coming_screen}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div>
                                    <h3>"Coming Soon" Screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>DescriptionText_Color</h3>
                                    <p>This is the color of the only piece of text on the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="noticeboard-menu" className="sectionFormatting">
                            <h2>"NoticeboardMenu"</h2>
                            <p>This is a screen that shows players announcements, and important information about
                                different
                                parts of our game.
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.nb_layer1}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Noticeboard 1.png!"
                                />
                                <div>
                                    <h3>Noticeboard Main Menu (Layer 1)</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the text that overarches the entire menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>Menu_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls for the whole menu (the pink
                                        thing
                                        in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>Menu_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[5]</h4>
                                    <h3>ArticleElement_HeadlineColor</h3>
                                    <p>This is the color of the text that shows an Article's headline.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>ArticleGroup_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls, for the entirety of an "Article
                                        Group" -<br></br>
                                        (in this case, the group you see is "GAME NOTICES", but we'll add more soon.)
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>ArticleGroup_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <p>There's a second layer too, we need to actually be able to control the menu the player
                                views
                                an Article in.
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.nb_layer2}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Noticeboard 2.png!"
                                />
                                <div>
                                    <h3>Noticeboard "Article Viewer" (Layer 2)</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>ArticleView_HeadlineTextColor</h3>
                                    <p>This is the color of the full, actual headline.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>ArticleView_ArticleContentsTextColor</h3>
                                    <p>This is the color of all the Article's content.<br></br>Namely, yap...
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[3]</h4>
                                    <h3>ArticleView_UploadDateLabelTextColor</h3>
                                    <p>This is the color of the text that says "UPLOAD DATE".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ArticleView_UploadDateTextColor</h3>
                                    <p>This is the color of the upload date.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>ArticleView_AuthorLabelTextColor</h3>
                                    <p>This is the color of the text that says "AUTHOR".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>ArticleView_AuthorTextColor</h3>
                                    <p>This is the color of the Author's name.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="theme-menu" className="sectionFormatting">
                            <h2>"ThemeMenu"</h2>
                            <p>This screen allows the player to manage the Themes they have installed.
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.themes_layer1}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Themesssss.png!"
                                />
                                <div>
                                    <h3>Theme Picker (Layer 1) Screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the text at the top of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>

                            <div className="property-array-align">
                                <div>
                                    <h4>[3]</h4>
                                    <h3>InstalledThemes_TitleTextColor</h3>
                                    <p>This is the color of the text on the left of the screen which says "INSTALLED
                                        THEMES".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>InstalledThemes_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>InstalledThemes_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[6]</h4>
                                    <h3>ActiveTheme_TitleTextColor</h3>
                                    <p>This is the color of the text on the left of the screen which says "ACTIVE
                                        THEME".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>ActiveTheme_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[8]</h4>
                                    <h3>ActiveTheme_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[9]</h4>
                                    <h3>AttributeDivider_Color</h3>
                                    <p>This is a color of a "divider" (the line splitting the two sides of the screen
                                        up). <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[10]</h4>
                                    <h3>ThemeButton_Color</h3>
                                    <p>This is the color of a button that shows a Theme, if it is a custom
                                        theme. <br></br>
                                        <span className="dimensionsText"> Default Color: #87034C </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[11]</h4>
                                    <h3>BaseGameThemeButton_Color</h3>
                                    <p>This is the color of a button that shows a Theme,
                                        <br></br>if it is an official theme shipped
                                        with the game. <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#B28106"}}> Default Color: #B28106 </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[12]</h4>
                                    <h3>ThemeButton_TitleTextColor</h3>
                                    <p>This is the color of the text that shows the name of a theme. <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[13]</h4>
                                    <h3>ThemeButton_CreatorsTextColor</h3>
                                    <p>This is the color of the text that shows who made the theme. <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[14]</h4>
                                    <h3>ThemeButton_DescriptionTextColor</h3>
                                    <p>This is the color of the text that shows short description of the
                                        theme. <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[15]</h4>
                                    <h3>ThemeButton_VersionTextColor</h3>
                                    <p>This is the color of the that shows the version of the theme you have,
                                        installed. <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.themes_layer2}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Themesssss.png!"
                                />
                                <div>
                                    <h3>"Your Themes" Picker (Layer 2) Screen</h3>
                                </div>
                            </div>

                            <div className="property-array-align">
                                <div>
                                    <h4>[16]</h4>
                                    <h3>Attribute_TitleTextColor</h3>
                                    <p>This is the title text color of the "LEARN" attribute.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[17]</h4>
                                    <h3>Attribute_DescriptionTextColor</h3>
                                    <p>This is the description of the "LEARN" attribute.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[18]</h4>
                                    <h3>Developer_AllThemesTitleTextColor</h3>
                                    <p>This is the color of the text that says "THEMES YOU'VE MADE".
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[19]</h4>
                                    <h3>AllThemes_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[20]</h4>
                                    <h3>AllThemes_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="developer-theme-dashboard-menu" className="sectionFormatting">
                            <h2>"DeveloperThemeDashboardMenu"</h2>
                            <p>This screen allows the player to use some development tools for a Theme they created.
                                <br></br>
                                You're going to use this screen later once we've done all the other stuff. :)
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.theme_devenv}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Theme Dev_Env.png!"
                                />
                                <div>
                                    <h3>Theme Development Area</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the text at the top of the screen.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[3]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the text that show's the current Theme's name.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ThemeCreators_TextColor</h3>
                                    <p>This is the text that shows who made the current Theme.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[5]</h4>
                                    <h3>ThemeVersion_TextColor</h3>
                                    <p>This is the text that shows the current Theme's version.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[6]</h4>
                                    <h3>ThemeShortDescription_TextColor</h3>
                                    <p>This is the text that shows the current Theme's short description.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[7]</h4>
                                    <h3>ThemeRegularDescription_TextColor</h3>
                                    <p>This is the text that shows the Theme's longer description.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                            <p>The next two variables are probably not going to be used, unless you yap a lot in your
                                Theme
                                description.
                            </p>
                            <div className="property-array-align">
                                <div>
                                    <h4>[8]</h4>
                                    <h3>Dashboard_ScrollbarBackingColor</h3>
                                    <p>The color of the little lines behind the scrollbar.
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#626262"}}> Default Color: #626262 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[9]</h4>
                                    <h3>Dashboard_ScrollbarColor</h3>
                                    <p>The color of the actual thing the player scrolls (the pink thing in the photo).
                                        <br></br>
                                        <span className="dimensionsText"
                                              style={{color: "#FF0776"}}> Default Color: #FF0776 </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="multiplayer-connecting-menu" className="sectionFormatting">
                            <h2>"Multiplayer_ConnectingMenu"</h2>
                            <p>This is a screen that's shown when connecting to multiplayer servers.
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.multiplayer_loading}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div>
                                    <h3>Multiplayer Loading Screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>Connecting_TextColor</h3>
                                    <p>This is the color of the text that says "CONNECTING..."
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>LongDescription_TextColor</h3>
                                    <p>This is the color of the text below the Connecting text.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ShowLoadingCircle</h3>
                                    <p>This decides whether you want to see the loading circle while loading into
                                        Multiplayer.
                                        I <b><u>STRONGLY </u></b>
                                        suggest you leave this on, so users know if their game, or internet, is having
                                        issues.
                                        <br></br>
                                        <span className="dimensionsText"> Default Value: true </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="multiplayer-connect-error-screen" className="sectionFormatting">
                            <h2>"Multiplayer_ConnectErrorScreen"</h2>
                            <p>This is a screen that's shown when the player fails to connect to Multiplayer servers.
                                <br></br>
                            </p>
                            <div className="leftright-textimage-align">
                                <img
                                    src={Images.multiplayer_error}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Custom Menu.png!"
                                />
                                <div>
                                    <h3>Multiplayer Error Screen</h3>
                                </div>
                            </div>
                            <div className="property-array-align">
                                <div>
                                    <h4>[1]</h4>
                                    <h3>PanelColor</h3>
                                    <p>This is used for the panel (the black square in the photo) that is behind the
                                        menu.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #000000 </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[2]</h4>
                                    <h3>MenuTitle_TextColor</h3>
                                    <p>This is the color of the menu's main text at the top-center of the panel.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[3]</h4>
                                    <h3>LongDescription_TextColor</h3>
                                    <p>This is the color of the text at the center of the screen, it shows why you got
                                        the
                                        error you got.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                                <div>
                                    <h4>[4]</h4>
                                    <h3>ErrorCode_TextColor</h3>
                                    <p>This is the color of the text that shows the error code you got.
                                        <br></br>
                                        <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div id="next-section" className="sectionFormatting">
                            <h2>Next Section: Game.polybeatsconfig</h2>
                            <p>
                                This is a LOT smaller than Menu.polybeatsconfig, but still important to the UI of the
                                game, because this is shown during a map playthrough.
                            </p>

                            <Link to="/tutorial-archive/themes/game.polybeatsconfig">
                                <button className="fof-menu-button"><span>Game.polybeatsconfig -></span></button>
                            </Link>
                        </div>
                    </div>
            </div>
        </div>
            );
            }